import React from 'react';
import { smartScenes, roomLevels } from '../mock';
import Reveal from './Reveal';

const Features = () => {
  return (
    <section id="features" className="bg-white py-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <Reveal variant="up">
          <div className="text-center mb-14">
            <div className="text-[#D4A853] tracking-[0.3em] text-xs font-semibold mb-3">SMART FEATURES FOR MODERN LIVING</div>
          </div>
        </Reveal>

        <div className="grid lg:grid-cols-3 gap-10 items-center">
          {/* Voice commands */}
          <Reveal variant="left">
            <h3 className="text-2xl font-bold text-[#0B1430] mb-6 text-center lg:text-left">Voice Commands</h3>
            <div className="space-y-5">
              <div className="flex items-start gap-3">
                <div className="w-12 h-12 rounded-full bg-[#00A8E1]/10 flex items-center justify-center shrink-0">
                  <div className="w-7 h-7 rounded-full bg-[#00A8E1]" />
                </div>
                <div className="bg-[#FBF3E2] rounded-2xl rounded-tl-sm px-5 py-3 text-[14px] text-[#0B1430] font-medium">
                  “Alexa, turn on<br/>living room lights.”
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-purple-400 via-pink-400 to-blue-400 shrink-0" />
                <div className="bg-[#FBF3E2] rounded-2xl rounded-tl-sm px-5 py-3 text-[14px] text-[#0B1430] font-medium">
                  “Hey Siri, set<br/>movie mode.”
                </div>
              </div>
            </div>
          </Reveal>

          {/* Smart Scenes */}
          <Reveal variant="up" delay={150}>
            <h3 className="text-2xl font-bold text-[#0B1430] mb-6 text-center">Smart Scenes</h3>
            <div className="grid grid-cols-2 gap-3">
              {smartScenes.map((s) => (
                <div key={s.name} className="scene-card aspect-[5/3]">
                  <img src={s.image} alt={s.name} className="w-full h-full object-cover" />
                  <div className="scene-card-label">{s.name}</div>
                </div>
              ))}
            </div>
          </Reveal>

          {/* Phone room control */}
          <Reveal variant="right" delay={250}>
            <div className="flex justify-center">
              <div className="w-[280px] phone-mock p-3">
                <div className="bg-white rounded-[28px] overflow-hidden">
                  <div className="flex justify-between items-center px-5 pt-4 text-[#0B1430] text-xs">
                    <span>9:41</span>
                    <span className="text-gray-400">•••</span>
                  </div>
                  <div className="px-5 py-4 border-b border-gray-100">
                    <div className="text-xs text-gray-400">←</div>
                    <div className="text-[#0B1430] text-xl font-semibold mt-1">My Home</div>
                  </div>
                  <div className="flex gap-4 px-5 py-3 text-[11px] border-b border-gray-100">
                    <span className="text-[#D4A853] font-semibold border-b-2 border-[#D4A853] pb-1">Rooms</span>
                    <span className="text-gray-400">Scenes</span>
                    <span className="text-gray-400">Devices</span>
                  </div>
                  <div className="px-5 py-3 space-y-4">
                    {roomLevels.map((r) => (
                      <div key={r.name}>
                        <div className="flex items-center justify-between mb-1.5">
                          <div className="flex items-center gap-2">
                            <div className="w-7 h-7 rounded-full bg-[#D4A853]/15 flex items-center justify-center">
                              <div className="w-3 h-3 rounded-full bg-[#D4A853]" />
                            </div>
                            <span className="text-[12px] text-[#0B1430] font-medium">{r.name}</span>
                          </div>
                          <span className="text-[12px] text-[#0B1430] font-semibold">{r.level}%</span>
                        </div>
                        <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
                          <div className="h-full bg-[#D4A853] rounded-full" style={{ width: `${r.level}%` }} />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Features;
